export default __webpack_public_path__ + "Un-Changed-white-icon.svg";